export class State {
  error: Record<string, any> | null = null;
  success = false;
  isLoading = false;
  data: any = null;
  total = 0;
}
